module.exports = "./images/logo-icon@2x.png?a37ff9ebe0550aa757f0e7a18ec7d098";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-icon@2x.png
// module id = 344
// module chunks = 0